<mat-card>
  <mat-card-header>
    <h1 mat-card-title>{{ 'reset_Password_tr' | translate }}</h1>
  </mat-card-header>

  <mat-card-content>
    <div>
      {{ 'Please_enter_a_new_password_tr' | translate }}
    </div>
    <form [formGroup]="form">
      <input [value]="email" autocomplete="username" hidden />
      <mat-form-field>
        <mat-label>{{ 'Password_tr' | translate }}</mat-label>
        <input formControlName="password" matInput type="password" autocomplete="new-password" />
        @if (form.controls.password.hasError('minlength')) {
          <mat-error>
            {{ 'Password_must_be_at_least_8_characters_tr' | translate }}
          </mat-error>
        }
        @if (form.controls.password.hasError('required')) {
          <mat-error>
            {{ 'Password_is_required_tr' | translate }}
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ 'repeat_Password_tr' | translate }}</mat-label>
        <input formControlName="rePassword" matInput type="password" autocomplete="new-password" />
        <mat-error>{{ 'password_does_not_match_tr' | translate }}</mat-error>
      </mat-form-field>

      <form-actions>
        <button type="submit" (click)="updatePassword()" [disabled]="form.invalid || !form.dirty" color="primary" mat-raised-button>
          <mat-icon>exit_to_app</mat-icon>
          {{ 'set_Password_tr' | translate }}
        </button>
      </form-actions>

      @if (showV2Fallback) {
        <app-recaptcha-v2-fallback (solved)="onV2Solved($event)" />
      }
    </form>
  </mat-card-content>

  <mat-card-actions>
    <a [routerLink]="['/login']">
      {{ 'back_to_login_page_tr' | translate }}
    </a>
  </mat-card-actions>
</mat-card>
